<template>
  <div v-if="SHOW_HELP_MODAL">
    <!-- <span>Modal is registered</span> -->
    <modal :show.sync="SHOW_HELP_MODAL" class="modal-primary" :show-close="false" header-classes="justify-content-center" type="mini">
      <div slot="header" style="padding: 0.5em" class="modal-profile d-flex justify-content-center align-items-center">
        <active-support-svg></active-support-svg>
      </div>
      <p> {{$t('message.Learn how to use the app with the help of video tutorials')}}</p>

      <template slot="footer">
        <n-button type="primary" round @click.native="cancel()">{{$t('message.Cancel')}}</n-button>
        <n-button type="primary" round @click.native="goToHelpPage()"> {{$t('message.show')}}</n-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "src/components";
import ActiveSupportSvg from "./svg_images/ActiveSupportSvg.vue";

export default {
  name: "need-help-modal",

  components: {
    Modal,
    ActiveSupportSvg,
  },

  data() {
    return {
      canceled: false,
    };
  },

  computed: {
    SHOW_HELP_MODAL() {
      return !localStorage.appUsed && !this.canceled && this.helpVideosAdded();
    },
  },

  methods: {
    helpVideosAdded() {
      if (
        this.settings.appsettings &&
        this.settings.appsettings.videos &&
        this.settings.appsettings.videos.length > 0
      ) {
        return true;
      } else {
        this.cancel();
        return false;
      }
    },
    cancel() {
      localStorage.appUsed = true;
      this.canceled = true;
      // this.SHOW_HELP_MODAL = false;
    },
    goToHelpPage() {
      // set the locl storage prop
      localStorage.appUsed = true;
      // route to help page
      this.$router.push("/helpvideos");
    },
  },
};
</script>

<style scoped>
/deep/.modal-content .modal-body {
  padding-left: 1em !important;
  padding-right: 1em !important;
}
</style>
